import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=4831c1f5&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831c1f5",
  null
  
)

export default component.exports